import React from 'react';

const hint = (realm, edition) => {
  const stone = realm.stones.find((s) => Boolean(s.ex) === (edition === 'ex')) || realm.stones[0];
  const metals = edition === 'ex' || realm.metalsInOriginal ? 'Sterling Silver or 14k White Gold' : 'metal to be announced';
  return `${stone.label} · ${metals}`;
};

export const EditionToggle = ({ realm, config, compact = false, id = 'edition' }) => (
  <div className={`aedition ${compact ? 'aedition--compact' : ''}`} data-testid={`${id}-toggle`}>
    <div className="aedition-seg" role="radiogroup" aria-label="Edition">
      {['original', 'ex'].map((e) => (
        <button
          key={e}
          type="button"
          role="radio"
          aria-checked={config.edition === e}
          className={`aedition-btn ${config.edition === e ? 'is-active' : ''}`}
          onClick={() => config.setEdition(e)}
          data-testid={`${id}-${e}`}
        >
          {e === 'ex' ? 'EX' : 'Original'}
        </button>
      ))}
    </div>
    <p className="aedition-hint" data-testid={`${id}-hint`}>{hint(realm, config.edition)}</p>
  </div>
);
